import React from 'react';

interface ICollapseProps {
    id: string;
    active: boolean;
    desktop: boolean;
    children: React.ReactNode;
}

export function Collapse({ id, active, desktop, children }: ICollapseProps) {
    return (
        <div
            id={id}
            className={
                'collapse' +
                (active ? ' show' : '') +
                (desktop ? '' : ' not-collapse-desktop')
            }
        >
            {children}
        </div>
    );
}
